var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceOrdoMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-162 -619.413)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(149 605.413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1,27.408a2.723,2.723,0,1,1,0-5.4,2.708,2.708,0,1,1,0,5.369Z",
    transform: "translate(4.286 9.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.015,27.4a2.708,2.708,0,1,1,0-5.369,2.708,2.708,0,1,1,0,5.369Z",
    transform: "translate(8.141 9.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.066,22.62a5.789,5.789,0,0,1,5.82-6.225,5.851,5.851,0,0,1,5.836,6.225,6.692,6.692,0,0,1-.451,2.49h6.863A12.107,12.107,0,0,0,35.4,22.6a11.921,11.921,0,0,0-12.45-11.921c-7.454,0-12.559,5.322-12.559,11.921a12.107,12.107,0,0,0,.28,2.583h6.894a6.692,6.692,0,0,1-.5-2.568Z",
    transform: "translate(2.822 3.508)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOrdoMenu);
export default __webpack_public_path__ + "static/media/place-ordo-menu.53188c090d718ec58b29e2df6a1e331a.svg";
export { ForwardRef as ReactComponent };